import React from "react"
import StatusPin from "./StatusPin"

const ShelfIcon = () => (
  <svg
    width="137"
    height="9"
    viewBox="0 0 137 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1C0 0.447715 0.447715 0 1 0H135.286C135.838 0 136.286 0.447715 136.286 1V5C136.286 7.20914 134.495 9 132.286 9H4C1.79086 9 0 7.20914 0 5V1Z"
      fill="#161617"
    />
    <path
      d="M135.205 6.42842L1.28726 6.42853C0.644125 6.4285 -0.000976622 5.78568 0.644405 7.07139C1.03106 7.84166 3.15901 8.99996 4.50155 8.99996L129.419 8.99985C132.803 8.99985 134.68 7.8397 135.478 6.951C135.675 6.73121 135.5 6.42842 135.205 6.42842Z"
      fill="black"
    />
    <circle cx="62.3577" cy="3.21439" r="0.642857" fill="#3990FF" />
    <circle cx="72.6429" cy="3.21439" r="0.642857" fill="#D9D9D9" />
    <circle
      cx="67.4989"
      cy="3.21422"
      r="1.80357"
      fill="#323232"
      stroke="black"
      stroke-width="0.25"
    />
  </svg>
)

// const StatusPin = () => (
//   <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M9.60156 8.09839L1.60156 8.09839" stroke="#717171" stroke-linecap="round"/>
// <g filter="url(#filter0_d_1073_8111)">
// <rect x="18.6016" y="4" width="8" height="8" rx="4" transform="rotate(90 18.6016 4)" fill="#06CB21"/>
// <rect x="18.1016" y="4.5" width="7" height="7" rx="3.5" transform="rotate(90 18.1016 4.5)" stroke="black"/>
// </g>
// <path d="M1.60156 6.5L0.601562 8L1.60156 9.5" stroke="#222222" stroke-linecap="round"/>
// <defs>
// <filter id="filter0_d_1073_8111" x="6.60156" y="0" width="16" height="16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
// <feFlood flood-opacity="0" result="BackgroundImageFix"/>
// <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
// <feOffset/>
// <feGaussianBlur stdDeviation="2"/>
// <feComposite in2="hardAlpha" operator="out"/>
// <feColorMatrix type="matrix" values="0 0 0 0 0.0235294 0 0 0 0 0.792157 0 0 0 0 0.12549 0 0 0 1 0"/>
// <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1073_8111"/>
// <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1073_8111" result="shape"/>
// </filter>
// </defs>
// </svg>
// )

export default function Shelf({
  data,
  centered = false,
  showPin = true,
  type = "",
}) {
  if (!data || Object.keys(data).length === 0) return null
  return (
    <div
      className={`shelf-wrap${centered ? " centered" : ""}`}
      title={data?.label || data?.key || "Shelf"}
    >
      {showPin ? <StatusPin online={!!data?.isOnline} type={type} /> : null}
      {/* <div className="shelf-bar"></div> */}
      <span className="shelf-bar">
        <ShelfIcon />
      </span>
    </div>
  )
}
